/**
 * Las filas que la dependencia de fechas marcó como inválidas, por tabla.
 *
 * El backend las marca (la columna field_rules_are_valid, ver
 * fechas/rule_types.py), pero el frontend del core 2.3.3 ni las trae ni las
 * pinta: el store fieldRules solo guarda las reglas y los datos de cada fila no
 * llevan esa columna. Solo salen en /database/field-rules/<tabla>/invalid-rows/.
 * Aquí se piden y se guardan; VigiaDeFechas decide cuándo y BotonDeFila las
 * pinta.
 *
 * Es un objeto reactivo de módulo y no un módulo de Vuex porque solo se escribe
 * en el navegador: en el servidor queda vacío y la marca sale al hidratar. Así
 * no hay que registrar nada en el store ni pelear con el orden de los plugins.
 */
import { reactive } from 'vue'

export const TIPO = 'dependencia_fechas_mg'

const porTabla = reactive({})
const turnos = {}

/** La dependencia de la tabla si está prendida y sin columnas rotas. */
export function reglaEnUso(store, tablaId) {
  const regla = store.getters['fieldRules/getRulesByType']({
    tableId: tablaId,
    ruleType: TIPO,
  })[0]
  return regla && regla.is_active && regla.is_valid ? regla : null
}

export function esInvalida(tablaId, filaId) {
  return porTabla[tablaId]?.[filaId] === true
}

/**
 * Cada pedido saca turno. Si mientras llega una respuesta ya se pidió otra (o se
 * apagó la regla), la vieja se descarta: la última edición manda.
 */
const turno = (tablaId) => (turnos[tablaId] = (turnos[tablaId] || 0) + 1)

export function olvidar(tablaId) {
  turno(tablaId)
  delete porTabla[tablaId]
}

export async function traer(client, tablaId) {
  const mio = turno(tablaId)
  const ids = {}
  for (let pagina = 1; ; pagina++) {
    const { data } = await client.get(
      `/database/field-rules/${tablaId}/invalid-rows/`,
      { params: { page: pagina, size: 200 } }
    )
    data.results.forEach(({ id }) => {
      ids[id] = true
    })
    if (!data.next) break
  }
  if (turnos[tablaId] === mio) {
    porTabla[tablaId] = ids
  }
}
